var HeaderContent = require("./HeaderContent"),
    HeaderGraphic = require("app/ui/HeaderGraphic/GraphicContainer"),
    Layout        = require("./PrefixLayout"),
    NoContentView = require("./NoContentView"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

require("./Prefix.less");

module.exports = kind(/** @lends app.HomePage.Prefix.prototype */ {

    /**
     * @private
     */
    name: "app.HomePage.Prefix",

    /**
     * @private
     */
    classes: "app-home-page-prefix",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * Dimensions of the scroller, passed along programmatically. Don't modify.
     *
     * @readonly
     * @public
     */
    scrollerDimensions: null,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:       "header",
        classes:    "app-home-page-prefix__header",
        components: [{
            name:    "headerGraphic",
            kind:    HeaderGraphic,
            classes: "app-home-page-prefix__header-graphic"
        }, {
            name:    "headerContent",
            kind:    HeaderContent,
            classes: "app-home-page-prefix__header-content"
        }]
    }, {
        name:    "noContent",
        kind:    NoContentView,
        classes: "app-home-page-prefix__no-content",
        showing: false
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.headerGraphic.state"
    }, {
        from: ".state",
        to:   ".$.headerContent.state"
    }, {
        from: ".$.headerGraphic.layoutMetrics",
        to:   ".headerGraphicLayoutMetrics"
    }, {
        from: ".headerGraphicLayoutMetrics",
        to:   ".$.headerContent.headerGraphicLayoutMetrics"
    }, {
        from: ".$.headerContent.layoutMetrics",
        to:   ".headerContentLayoutMetrics"
    }],

    /**
     * @private
     */
    observers: {
        lazyReflowHeader: ["headerGraphicLayoutMetrics", "headerContentLayoutMetrics"],
        update:           ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.lazyReflowHeader = frameThrottle(this.bindSafely(this.reflowHeader));
            this.update           = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var state         = this.state || {},
            numDashboards = get(state, "data.dashboard.length", 0);

        this.$.noContent.set("showing", numDashboards === 0);
        this.resize();
    },

    /**
     * Full reflow
     *
     * @private
     */
    reflow: function() {
        this.layout.reflow();
    },

    /**
     * Reflow the header only
     *
     * @private
     */
    reflowHeader: function() {
        this.layout.reflowHeader();
    }

});
